export default __webpack_public_path__ + "static/media/MT.7ff69efb.svg";